import React, { useEffect, useState } from "react";
import CustomSkeleton from "../../../control-components/skeleton/skeleton";
import { ListView, ListViewHeader } from "@progress/kendo-react-listview";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { clinicService } from "../../../services/clinicService";
import { NotificationManager } from "src/util/notify";
import { Loader } from "@progress/kendo-react-indicators";

import moment from "moment";

const Days = [
  { name: "Current Month", value: "currentMonth" },
  { name: "Last 3 Months", value: "last3Months" },
  { name: "Last 6 Months", value: "last6Months" },
  { name: "Last 9 Months", value: "last9Months" },
  { name: "Last 1 Year", value: "last1Year" },
];

const ClinicTemplateInfo = ({ clinicInfo }) => {
  const [isShowItems, setShowItems] = useState(false);
  const [day, setDay] = useState({ name: "Last 3 Months", value: "last3Months" });
  const [clinicTemplateInfo, setClinicTemplateInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [TotalTemplate, setTotalTemplate] = useState(0);

  useEffect(() => {
    if (clinicInfo !== null || clinicInfo !== undefined) {
      getClinicTemplateInfo();
      let totalTemp = clinicTemplateInfo.reduce(
        (acc, item) => acc + item.totByMonth,
        0
      );
      setTotalTemplate(totalTemp);
    }
  }, [day]);

  useEffect(() => {
    let totalTemp = clinicTemplateInfo.reduce(
      (acc, item) => acc + item.totByMonth,
      0
    );
    setTotalTemplate(totalTemp);
  }, [clinicTemplateInfo]);

  const getClinicTemplateInfo = async () => {
    setLoading(true);

    const endDate = new Date();
    let startDate = new Date();

    switch (day.value) {
      case "currentMonth":
        startDate.setDate(1);
        break;
      case "last3Months":
        startDate.setMonth(endDate.getMonth() - 2);
        startDate.setDate(1);
        break;
      case "last6Months":
        startDate.setMonth(endDate.getMonth() - 5);
        startDate.setDate(1);
        break;
      case "last9Months":
        startDate.setMonth(endDate.getMonth() - 8);
        startDate.setDate(1);
        break;
      case "last1Year":
        startDate.setFullYear(endDate.getFullYear() - 1);
        startDate.setMonth(endDate.getMonth());
        startDate.setDate(1);
        break;
      default:
        startDate.setDate(1);
    }

    const dateObject = {
      clinicId: clinicInfo.field.masterClinicId,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      regionId: clinicInfo.field.regionId,
    };

    await clinicService
      .getClinicTemplateInfo(dateObject)
      .then((result) => {
        setLoading(false);
        const data = result.resultData;
        setClinicTemplateInfo(data);
        setShowItems(true);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleChange = (e) => {
    setDay(e.value);
  };

  const MyHeader = () => {
    return (
      <ListViewHeader className="listview-header">
        <div className="row border-bottom align-middle m-0 py-2">
          <div className="col">
            <h6 className="f-14">Month</h6>
          </div>
          <div className="col">
            <h6 className="f-14">Total Template</h6>
          </div>
        </div>
      </ListViewHeader>
    );
  };

  const MyItemRender = (props) => {
    let item = props.dataItem;
    return (
      <>
        {clinicTemplateInfo?.length > 0 ? (
          <div className="row py-2 border-bottom align-middle listview-row m-0">
            <div className="col">
              {!isShowItems ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>
                  {item.monthName} {item.yr}
                </div>
              )}
            </div>
            <div className="col">
              {!isShowItems ? (
                <CustomSkeleton shape="text" />
              ) : (
                <div>{item.totByMonth}</div>
              )}
            </div>
          </div>
        ) : (
          "No Data Found"
        )}
      </>
    );
  };

  return (
    <>
      {loading === true ? <Loader /> :
        <div className="clinic-template-container bg-white p-3">
          <div className="clinic-template-header pb-2">
            <div className="clinic-template-header-content">
              <h5 className="clinic-template-title">Documents by Month</h5>
              <div className="clinic-template-dropdown">
                <DropDownList
                  onChange={handleChange}
                  data={Days}
                  value={day}
                  textField="name"
                  dataItemKey="value"
                  defaultValue={Days[0].value}
                />
              </div>
            </div>
          </div>
          {clinicTemplateInfo.length > 0 ? (
            <ListView
              data={clinicTemplateInfo}
              item={MyItemRender}
              className="listview-container"
              header={MyHeader}
            />
          ) : (
            <div className="no-data-container">No data found</div>
          )}
        </div>
      }

      <div className="total-template-container">
        {loading === false ? (
          <div className="total-template-info">
            <i className="fa fa-file-text total-template-icon"></i>
            <span>Total Documents: {TotalTemplate}</span>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </>
  );
};

export default ClinicTemplateInfo;
